import { render, staticRenderFns } from "./WsaPhoneNumber.vue?vue&type=template&id=8ed9625c"
import script from "./WsaPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./WsaPhoneNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports